import { ConfigMarket, IConfigMarket, WalletTypes } from '@Redux/interfaces'

import {
  ORDER_TYPE_NAME,
  Type,
} from '@UI/crypto_exchange/desktop/pages/spot/components/SpotOrderTrade/containers/types'

import { FormType } from './LimitOrderBlock/model'

export interface ISpotTradeBlockProps {
  current_market: ConfigMarket
}

export interface IAllValTradeInput {
  price: string
  amount: string
  range: number
  total: string
}

export interface ITradeBlockProps {
  current_market: ConfigMarket

  sendMessage?: (
    amount: number,
    market: ConfigMarket,
    action: string,
    rate: number,
    wallet_id: number,
    payload: FormType,
  ) => void
  orderType: ORDER_TYPE_NAME
  walletType?: WalletTypes
}

export interface ICombinedMarketInputProps {
  current_market: IConfigMarket
  selectedInput: TRADE_INPUT_NAME
  recalculationValues: (e: string, name: TRADE_INPUT_NAME) => void
  allValues: IAllValTradeInput
  balanceAmount: number
}

export enum ORDER_ACTION_TYPE {
  BUY = 'buy',
  SELL = 'sell',
}

export enum TRADE_INPUT_NAME {
  PRICE = 'price',
  AMOUNT = 'amount',
  TOTAL = 'total',
  RANGE = 'range',
}

export enum MARGIN_TYPE {
  NORMAL = 'normal',
  BORROW = 'borrow',
  REPAY = 'repay',
}

export enum GET_TEXT {
  InfoMessageLimitOrderType = 'A limit order is an order to buy or cell at a specific price or better. Limit orders are not guaranteed to execute.',
  InfoMessageMarketOrderType = 'Market order is immediately matched to the best available market price.',
  InfoMessageStopLimitOrderType = 'To buy or sell a coin once the price reaches a specified price.',
  InfoMessageNormalType = 'All trading rules are the same as in the exchange trading feature',
  InfoMessageBorrowType = 'The system will automatically borrow on your behalf to execute the order. Successfully placed orders will accrue interest immediately. If the placed order is cancelled in full, the principal will automatically be repaid.',
  InfoMessageRepayType = 'Assets received after a trade will automatically be used to repay the debt of the same coin in your margin account. If there is an insufficient amount when repaying, it will repay 90% of the debt only.',
}
